import React from 'react';
import Layout from "../components/layout/layout";
import "../sass/pages/about.scss";
import "../images/Lauren@2x.png"
import CallToAction from "../components/callToAction/callToAction";
import {StaticImage} from "gatsby-plugin-image";
import useScreenSize from "../Hooks/useScreenSize";



function About() {
    const [inRange] = useScreenSize(0,767);
    return (
        <Layout name={"about"} current={"about"} keywords={"Staser, creative"}>
            <h2 className={"mobile primary"}>about</h2>
            <hr className={"mobile"}/>
            <span className="about-content">
                    <aside>
                        <h2 className={"desktop"}>about</h2>
                        <hr className={"desktop"}/>
                        <p>
                                Hey there!
                                I’m a freelance creative with a passion for storytelling and problem solving.
                                Few things bring me greater enjoyment than creating visuals that tell a compelling narrative.
                                Clear communication is is vital to authentic human connection,
                                and I can’t think of a more fulfilling mission than using my trade to strengthen that link.
                                <br/>
                                <br/>
                                When I’m not busy creating alongside some of the best clients I could ask for,
                                or collaborating with like-minded creatives- you can probably find me exploring nature with my kiddo and pup,
                                daydreaming and scheming with the coolest person on earth (who happens to be my husband),
                                or somewhere with tacos.
                            </p>

                        <figcaption className={"img-caption mobile-only"}>
                            Photo Credits: <br/>
                            Robert Staser ( Left & Bottom ) <br/>
                            Chris Berneking ( right )
                        </figcaption>
                        <hr className={"mobile-only spaced-out"}/>
                        <CallToAction noTop alignLeft={!inRange}/>
                        <figcaption className={"img-caption desktop-only"}>
                            Photo Credits: <br/>
                            Robert Staser ( Left & Bottom ) <br/>
                            Chris Berneking ( right )
                        </figcaption>
                    </aside>
                    <figure className="image-container"
                            style={{
                                marginBottom: "2%",
                            }}
                    >
                        <StaticImage
                            src={"../images/AboutPageGraphic-01.png"}
                            alt={"Lauren and friends"}
                            width={591}
                            objectFit={"contain"}
                            loading={"eager"}
                            imgStyle={{
                                objectPosition: "top"
                            }}
                        />
                    </figure>
                </span>
        </Layout>
    );
}

export default About;
